import { BubbleMenu, Editor } from '@tiptap/react';
import { Bold, Italic, Underline, Strikethrough, Link as LinkIcon } from 'lucide-react';
import { Button } from '../../core/button';

type Props = { editor: Editor };

export function RichTextBubbleMenu({ editor }: Props) {
  const buttons: Array<{ icon: React.ComponentType<{ className?: string }>; cmd: () => void; active: () => boolean; label: string }> = [
    { icon: Bold, cmd: () => editor.chain().focus().toggleBold().run(), active: () => editor.isActive('bold'), label: 'Bold' },
    { icon: Italic, cmd: () => editor.chain().focus().toggleItalic().run(), active: () => editor.isActive('italic'), label: 'Italic' },
    { icon: Underline, cmd: () => editor.chain().focus().toggleUnderline().run(), active: () => editor.isActive('underline'), label: 'Underline' },
    { icon: Strikethrough, cmd: () => editor.chain().focus().toggleStrike().run(), active: () => editor.isActive('strike'), label: 'Strikethrough' },
    { icon: LinkIcon, cmd: () => {
      const url = window.prompt('Link URL');
      if (url) editor.chain().focus().setLink({ href: url }).run();
    }, active: () => editor.isActive('link'), label: 'Link' },
  ];

  return (
    <BubbleMenu editor={editor} tippyOptions={{ duration: 100 }} className="flex items-center gap-1 rounded-lg border bg-popover p-1 shadow-md">
      {buttons.map((b) => (
        <Button
          key={b.label}
          type="button"
          variant="ghost"
          size="sm"
          className={`h-7 w-7 p-0 ${b.active() ? 'bg-accent' : ''}`}
          aria-label={b.label}
          onClick={b.cmd}
        >
          <b.icon className="h-3.5 w-3.5" />
        </Button>
      ))}
    </BubbleMenu>
  );
}
